import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  SkeletonBlock,
  SkeletonLine,
  SkeletonPill,
} from './Skeleton.web';

export const DocumentDetailSkeleton = memo(function DocumentDetailSkeleton() {
  const { theme, isDark } = useTheme();
  const cardBg = isDark ? theme.surfaceElevated : 'rgba(255,255,255,0.82)';

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: theme.background,
        padding: 16,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          flex: 1,
          maxWidth: 760,
          width: '100%',
          borderRadius: 24,
          border: `1px solid ${theme.borderSubtle}`,
          backgroundColor: cardBg,
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}
      >
        <SkeletonLine width="62%" height={22} />
        <div style={{ display: 'flex', gap: 8 }}>
          <SkeletonPill width={84} height={22} />
          <SkeletonPill width={64} height={22} />
        </div>

        <div style={{ height: 1, backgroundColor: 'rgba(0,0,0,0.05)', marginBlock: 8 }} />

        <section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <SkeletonBlock height={14} />
          <SkeletonBlock height={14} />
          <SkeletonBlock height={14} width="92%" />
          <SkeletonBlock height={14} width="86%" />
          <SkeletonBlock height={14} width="74%" />
        </section>

        <section style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <SkeletonBlock height={14} />
          <SkeletonBlock height={14} width="88%" />
          <SkeletonBlock height={14} width="62%" />
        </section>
      </div>
    </div>
  );
});
